import React from 'react';
import queryString from 'query-string';
import envelop from '../../Assets/images/envelope.svg';
import './unsubscribe-confirmation-style.scss';
import { getLogo, getCompanyName } from '../../utils';

function UnsubscribeConfirmation(props) {
  const { location } = props;
  const { notify_email: notifyEmail } = location ? queryString.parse(location.search) : '';
  
  return (
      <div className="unsubscribe__form__wrapper card">
        <img src={getLogo(notifyEmail)} className="ttn__logo display--block" alt="ttn-logo" />
        <img src={envelop} className="envelop__logo display--block" alt="envelop" />
        <p className="text--heading">You've been unsubscribed </p>
        <p className="text--para">You've been unsubscribed from all {getCompanyName(notifyEmail)} emails </p>
      </div>
  );
}
export default UnsubscribeConfirmation;
